// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"search-input_inputWrapper__1dNua","searchInput":"search-input_searchInput__oxuvX","searchDelete":"search-input_searchDelete__onA2H"};